import React from 'react';
import { Field, NumericInput, RadioGroup, TextInput, TextOutput } from '../../../../../Components/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Components/Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Components/Layout';
import { WorksheetBalanceFieldSet } from '../../../../../Components/Worksheets/Core';
import { IWorksheetComponent } from '../../../../../Components/Worksheets/Core/types';
import { HydrometerPortionAgitationSection } from './HydrometerPortionAgitationSection';
import { HydrometerPortionContainsOversizeParticlesCheckbox } from './HydrometerPortionContainsOversizeParticlesCheckbox';

const HydrometerPortionPretreatmentPreparationSectionBase: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  return (
    <>
      <ListFieldSection heading="Material Mass">
        <NamePrefixModifier appendNamePrefix="Masses">
          <NamePrefixModifier appendNamePrefix="MassMeasurement">
            <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" />
            <Field input={<NumericInput />} name="TareMass" />
            <Field input={<NumericInput />} name="TareAndWetMass" />
          </NamePrefixModifier>
          <Field input={<TextOutput />} name="WetMass" />
        </NamePrefixModifier>
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="Pretreatment">
        <ListFieldSection>
          <Field input={<TextOutput />} name="UntreatedMaterialDryMass" />
          <Field
            input={<RadioGroup />}
            name="Reagent"
            options={['Hydrogen peroxide', 'Hydrochloric acid'].map((x) => ({ label: x, value: x }))}
            freeEntry={true}
            freeEntryLabel="Other"
            freeEntryMaxLength={100}
          />
          <Field
            input={<RadioGroup />}
            name="SeparationMethod"
            options={['Centrifuge', 'Sieve'].map((x) => ({ label: x, value: x }))}
            freeEntry={true}
            freeEntryLabel="Other"
            freeEntryMaxLength={100}
          />
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<TextInput />} name="TareID" />
          <Field input={<NumericInput />} name="TareMass" />
          <Field input={<NumericInput />} name="TareAndPretreatedMaterialDryMass" />
          <Field input={<TextOutput />} name="PretreatedMaterialDryMass" />
        </ListFieldSection>
      </NamePrefixModifier>

      <ListFieldSection>
        <HydrometerPortionContainsOversizeParticlesCheckbox appendNamePrefix="Preparation" />
      </ListFieldSection>

      <HydrometerPortionAgitationSection />
    </>
  );
};
const HydrometerPortionPretreatmentPreparationSection = withInjectedProps(
  HydrometerPortionPretreatmentPreparationSectionBase
);

export { HydrometerPortionPretreatmentPreparationSection };
export default HydrometerPortionPretreatmentPreparationSection;
